/* eslint-disable max-len */
<template>
  <div class="side-nav" @mouseleave="$emit('unhover')" @mouseenter="$emit('hover')">
    <!-- <el-button
      v-if="isCollapse" @click="collapse" class="arrow" icon="el-icon-d-arrow-right" size="mini">
    </el-button>
    <el-button v-else @click="collapse" class="arrow" icon="el-icon-d-arrow-left" size="mini"></el-button> -->
    <Menu
        mode="vertical"
        class="sidenav"
        text-color="#fff"
        active-text-color="#fff"
        unique-opened
        router
        collapse-transition
        :collapse="isCollapse"
    >
      <menu-item  @click="sitemapRoute" :style="{backgroundColor: routeName.includes('Sitemap') ? '#FF3300' : ''}">
        <i class="el-icon-menu icon-color"></i>
        <span>Site Map</span>
      </menu-item>
      <menu-item @click="() => routeOthers( 'dashboard' )" :style="{backgroundColor: routeName.includes('Dashboard') ? '#FF3300' : ''}">
        <i class="el-icon-s-home icon-color"></i>
        <span>Dashboard</span>
      </menu-item>
      <menu-item @click="() => routeOthers('leasing')" :style="{backgroundColor: routeName.includes('Leasing') ? '#FF3300' : ''}">
        <i class="el-icon-suitcase icon-color"></i>
        <span>Leasing</span>
      </menu-item>
      <el-submenu popper-class="submenu" class="icon-color submenu" index="/audit" :style="{backgroundColor: routeName.includes('Audit') ? '#FF3300' : ''}">
        <template slot="title">
          <i class="el-icon-s-order icon-color"></i>
          <span slot="title">Audit</span>
        </template>
        <el-menu-item-group>
          <menu-item @click="() => routeOthers('audit/commercial')">
            <i class="el-icon-ship icon-color"></i>
            <span slot="title">
              Commercial
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('audit/void')">
            <i class="el-icon-ship icon-color"></i>
            <span slot="title">
              Void charges
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('audit/credits')">
            <i class="el-icon-sell icon-color"></i>
            <span slot="title">
              Credits
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('audit/ccwf')">
            <i class="el-icon-discount icon-color"></i>
            <span slot="title">
              CC Waiver
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('audit/transactions')">
            <i class="el-icon-money icon-color"></i>
            <span slot="title">
              Failed Payments
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('audit/refunds')">
            <i class="el-icon-refresh-right icon-color"></i>
            <span slot="title">
              Refund Requests
            </span>
          </menu-item>
        </el-menu-item-group>
      </el-submenu>
      <menu-item @click="routeToCustomers" :style="{backgroundColor: routeName.includes('Customer') ? '#FF3300' : ''}">
        <i class="el-icon-s-custom icon-color"></i>
        <span>Members</span>
      </menu-item>
      <menu-item @click="unitsRoute" :style="{backgroundColor: routeName.includes('Unit') ? '#FF3300' : ''}">
        <i class="el-icon-s-grid icon-color"></i>
        <span>Units</span>
      </menu-item>
      <menu-item @click="() => routeOthers('payments')" :style="{backgroundColor: routeName.includes('Payments') ? '#FF3300' : ''}">
        <i class="el-icon-s-finance icon-color"></i>
        <span>Payments</span>
      </menu-item>
        <menu-item v-if="hasAccess" @click="() => routeOthers('pricing')" :style="{backgroundColor: routeName.includes('Pricing') ? '#FF3300' : ''}">
          <i class="el-icon-money icon-color"></i>
          <span>Pricing</span>
        </menu-item>
      <menu-item @click="() => routeOthers('availability')" :style="{backgroundColor: routeName.includes('Availability') ? '#FF3300' : ''}">
        <i class="el-icon-discover icon-color"></i>
        <span>Global Availability</span>
      </menu-item>
      <menu-item @click="facilitiesRoute" :style="{backgroundColor: (routeName.includes('Facilities') || routeName === 'Facility') ? '#FF3300' : ''}">
        <i class="el-icon-office-building icon-color"></i>
        <span>Facility</span>
      </menu-item>
      <el-submenu popper-class="submenu" class="icon-color submenu" index="/financials" :style="{backgroundColor: routeName.includes('Finance') ? '#FF3300' : ''}">
        <template slot="title">
          <i class="el-icon-bank-card icon-color"></i>
          <span slot="title">Financials</span>
        </template>
        <el-menu-item-group>
          <!-- <span slot="title">Group One</span> -->
          <menu-item @click="() => routeOthers('finance/balancesheet')">
            <i class="el-icon-tickets icon-color"></i>
            <span slot="title">
              Balance Sheet
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('finance/collections')">
            <i class="el-icon-collection icon-color"></i>
            <span slot="title">
              Collections
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('finance/report')">
            <i class="el-icon-data-analysis icon-color"></i>
            <span slot="title">
              Accrual Report
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('finance/revision')">
            <i class="el-icon-wallet icon-color"></i>
            <span slot="title">
              Wallet Detail
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('finance/deposits')">
            <i class="el-icon-sold-out icon-color"></i>
            <span slot="title">
              Deposits
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('finance/sales')">
            <i class="el-icon-s-check icon-color"></i>
            <span slot="title">
              Sales Tax
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('finance/move')">
            <i class="el-icon-truck icon-color"></i>
            <span slot="title">
              Move-In/Move-Out
            </span>
          </menu-item>
          <menu-item @click="() => routeOthers('unit/vacancy/aging')">
            <i class="el-icon-s-management icon-color"></i>
            <span slot="title">
              Unit Vacancy Aging
            </span>
          </menu-item>
        </el-menu-item-group>
      </el-submenu>
      <menu-item @click="() => routeOthers('occupancy')" :style="{backgroundColor: routeName.includes('Occupancy') ? '#FF3300' : ''}">
        <i class="el-icon-reading icon-color"></i>
        <span>Occupancy</span>
      </menu-item>
      <menu-item @click="() => routeOthers('risks')" :style="{backgroundColor: routeName.includes('Risks') ? '#FF3300' : ''}">
        <i class="el-icon-help icon-color"></i>
        <span>Risks</span>
      </menu-item>
      <menu-item @click="() => routeOthers('todo')" :style="{backgroundColor: routeName.includes('Todo') ? '#FF3300' : ''}">
        <i class="el-icon-s-claim icon-color"></i>
        <span>To-Do</span>
      </menu-item>
      <menu-item @click="() => routeOthers('comms')" :style="{backgroundColor: routeName.includes('Communication') ? '#FF3300' : ''}">
        <i class="el-icon-s-promotion icon-color"></i>
        <span>Communications</span>
      </menu-item>
      <!-- <SuperAdmin> -->
      <menu-item v-if="hasAccess" @click="() => routeOthers('users')" :style="{backgroundColor: routeName.includes('Users') ? '#FF3300' : ''}">
        <i class="el-icon-user icon-color"></i>
        <span>Users</span>
      </menu-item>
      <menu-item v-if="hasAccess" @click="() => routeOthers('config')" :style="{backgroundColor: routeName.includes('Config') ? '#FF3300' : ''}">
        <i class="el-icon-setting icon-color"></i>
        <span>Configurations</span>
      </menu-item>

      <!-- </SuperAdmin> -->
    </Menu>
  </div>
</template>

<script>
import { Menu, MenuItem, Image } from 'element-ui';
import SuperAdmin from './SuperAdmin.vue';

export default {
  name: 'TopNav',
  components: { Menu, MenuItem, Image, SuperAdmin },
  props: {
    isCollapse: { type: Boolean, default: false },
  },
  computed: {
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1')) {
        return true;
      }
      return false;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    collapse() {
      // this.isCollapse = !this.isCollapse;
      this.$emit('collapse', this.isCollapse);
    },
    sitemapRoute() {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/sitemap/${facility}`) {
        this.$router.push(`/sitemap/${facility}`);
        return;
      }
      this.$router.push('/sitemap');
    },
    unitsRoute() {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/units/${facility}`) {
        this.$router.push(`/units/${facility}`);
        return;
      }
      this.$router.push('/units');
    },
    routeToCustomers() {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/customers/${facility}`) {
        this.$router.push(`/customers/${facility}`);
        return;
      }
      this.$router.push('/customers');
    },
    facilitiesRoute() {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/facilities/${facility}`) {
        this.$router.push(`/facilities/${facility}`);
        return;
      }
      this.$router.push('/facilities');
    },
    routeOthers(index) {
      const { facility } = this.$router.history.current.params;
      if (facility && this.$router.history.current.fullPath !== `/${index}/${facility}`) {
        this.$router.push(`/${index}/${facility}`);
        return;
      }
      if (!facility) {
        this.$router.push(`/${index}`);
      }
    },
  },
};
</script>

<style scoped>
.sidenav, .el-menu-item-group {
    background: linear-gradient(35deg, #009aca, #6dd5ed);
    text-align: left;
}

.el-menu-item:focus, .el-submenu, .el-menu-item:hover {
    background-color: #ff3300e3;
    outline: 0;
}

.submenu, .submenu:hover {
    color: rgb(189, 188, 188);
    background-color: #58bbda;
    outline: 0;
}

.el-submenu__title:hover {
    background-color: #009aca !important;
    outline: 0;
}

.icon-color, .el-submenu__icon-arrow, .el-icon-arrow-down {
    color: #fff;
}

.icon-color-red, .el-submenu__icon-arrow, .el-icon-arrow-down {
    color: #ff3300e3;
}

.side-nav {
  height: 100%;
  overflow: hidden;
}

.arrow {
  /* margin-left: 30%; */
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/SideNav.vue